<template>
  <div class="home">
    <!-- <Navbar /> -->
    <vue-headful title="BLOCK LIST" />

    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>

      <fish-card fluid color="red">
        <div slot="header">DANH SÁCH KHÁCH HÀNG BLOCK / BLACKLIST</div>

        <a-table
          rowKey="User_ID"
          size="small"
          :columns="columns"
          :data-source="TBLdata"
          :pagination="false"
          :scroll="{ x: 1250 }"
        >
          <template slot="Entry_Count" slot-scope="text">
            {{ FormatNumber(text) }}
          </template>

          <template slot="Day_Win_Count" slot-scope="text, record">
            <strong
              :style="{
                color: record.IsBlock ? '#fa8c16' : '',
              }"
            >
              {{ FormatNumber(text) }}
            </strong>
          </template>

          <template slot="Win_Count" slot-scope="text, record">
            <strong
              :style="{
                color: record.IsBlackList ? '#f5222d' : '',
              }"
            >
              {{ FormatNumber(text) }}
            </strong>
          </template>

          <template slot="Customer_Status" slot-scope="text, record">
            <a-tag :color="record.IsBlackList ? 'red' : 'orange'">
              {{ record.IsBlackList ? "BLACKLIST" : "TẠM KHÓA" }}
            </a-tag>
          </template>

          <template slot="Modified_Date" slot-scope="text">
            {{ FormatDateTime(text) }}
          </template>

          <template slot="Note" slot-scope="text, record">
            <a-input
              v-if="record.editable"
              style="min-width: 220px"
              :value="record.EditNote"
              @change="
                (event) => handleChange(event.target.value, record.User_ID)
              "
            />

            <span v-else>
              {{ text || "---" }}
            </span>
          </template>

          <template slot="action" slot-scope="text, record">
            <span v-if="record.editable">
              <a-popconfirm
                title="Lưu ghi chú?"
                @confirm="() => CustSave(record.User_ID)"
              >
                <a-button size="small" type="primary" icon="save">
                  LƯU
                </a-button>
              </a-popconfirm>

              <a-button
                size="small"
                style="margin-left: 4px"
                icon="close"
                @click="() => CustCancel(record.User_ID)"
              >
                HỦY
              </a-button>
            </span>

            <span v-else>
              <a-button
                size="small"
                type="primary"
                icon="edit"
                :disabled="editingCust !== ''"
                @click="() => CustEdit(record.User_ID)"
              >
                SỬA
              </a-button>

              <a-popconfirm
                v-if="!record.IsBlackList"
                title="Khóa vĩnh viễn khách hàng này khỏi chương trình?"
                @confirm="() => CustBlacklist(record)"
              >
                <a-button
                  size="small"
                  type="danger"
                  icon="stop"
                  style="margin-left: 4px"
                >
                  BLACKLIST
                </a-button>
              </a-popconfirm>

              <a-button
                v-else
                size="small"
                type="danger"
                icon="stop"
                style="margin-left: 4px"
                disabled
              >
                BLACKLIST
              </a-button>
            </span>
          </template>
        </a-table>

        <div
          v-if="TBLdata && TBLdata.length"
          style="padding-top: 8px; text-align: right"
        >
          <a-pagination
            size="small"
            :current="page"
            :pageSize="pageSize"
            :total="TBLdataTotal"
            @change="onChange"
          />
        </div>
      </fish-card>

      <br />

      <a-alert type="info" show-icon>
        <template slot="message">
          <a-tag color="orange"> TẠM KHÓA </a-tag>
          = đạt giới hạn trúng thưởng trong ngày. &nbsp;&nbsp;

          <a-tag color="red"> BLACKLIST </a-tag>
          = đạt giới hạn toàn chương trình hoặc bị khóa thủ công.
        </template>
      </a-alert>
    </fish-segment>
  </div>
</template>

<script>
// import Navbar from "@/components/Navbar.vue";

const moment = require("moment");

export default {
  name: "BlockList",

  components: {
    // Navbar,
  },

  mounted() {
    this.fillData();
  },

  data() {
    return {
      isLoading: false,

      page: 1,

      pageSize: 100,

      editingCust: "",

      columns: [
        {
          title: "#",
          dataIndex: "Index",
          key: "Index",
          width: "50px",
        },
        {
          title: "KHÁCH HÀNG",
          dataIndex: "User_ID",
          key: "User_ID",
        },
        {
          title: "TỔNG LƯỢT NHẬP",
          dataIndex: "Entry_Count",
          key: "Entry_Count",
          scopedSlots: {
            customRender: "Entry_Count",
          },
        },
        {
          title: "TRÚNG HÔM NAY",
          dataIndex: "Day_Win_Count",
          key: "Day_Win_Count",
          scopedSlots: {
            customRender: "Day_Win_Count",
          },
        },
        {
          title: "TỔNG TRÚNG",
          dataIndex: "Win_Count",
          key: "Win_Count",
          scopedSlots: {
            customRender: "Win_Count",
          },
        },
        {
          title: "TRẠNG THÁI",
          dataIndex: "Customer_Status",
          key: "Customer_Status",
          scopedSlots: {
            customRender: "Customer_Status",
          },
        },
        {
          title: "NGÀY THAY ĐỔI",
          dataIndex: "Modified_Date",
          key: "Modified_Date",
          scopedSlots: {
            customRender: "Modified_Date",
          },
        },
        {
          title: "GHI CHÚ",
          dataIndex: "Note",
          key: "Note",
          scopedSlots: {
            customRender: "Note",
          },
        },
        {
          title: "CHỨC NĂNG",
          dataIndex: "action",
          key: "action",
          scopedSlots: {
            customRender: "action",
          },
        },
      ],

      TBLdata: [],

      TBLdataTotal: 0,
    };
  },

  computed: {
    oUser() {
      return this.$store.state.oUser || {};
    },
  },

  methods: {
    GetAPIData(Response) {
      return Response && Response.data ? Response.data : Response;
    },

    FormatNumber(Value) {
      return Number(Value || 0).toLocaleString("vi-VN");
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "---";
      }

      const DateValue = moment(Value);

      if (!DateValue.isValid()) {
        return "---";
      }

      return DateValue.format("DD/MM/YYYY HH:mm:ss");
    },

    BuildRecord(Customer, Index) {
      return Object.assign({}, Customer, {
        Index: (this.page - 1) * this.pageSize + Index + 1,

        Customer_Status: Customer.IsBlackList ? "blacklist" : "block",

        Modified_Date: Customer.IsBlackList
          ? Customer.BlackList_Date || Customer.Modified_At
          : Customer.Block_Date || Customer.Modified_At,

        EditNote: Customer.Note || "",
      });
    },

    async fillData() {
      try {
        this.isLoading = true;

        const Response = await this.$PostAPI("/block-list", {
          Token: this.oUser.Token,
          Page: this.page,
          PageSize: this.pageSize,
        });

        const Result = this.GetAPIData(Response);

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không tải được danh sách Block.",
            3000,
          );

          return;
        }

        const Data = Result.Data || {};

        this.TBLdataTotal = Number(Data.Total || 0);

        this.TBLdata = (Data.Customers || []).map((Customer, Index) =>
          this.BuildRecord(Customer, Index),
        );
      } catch (Error) {
        console.log("Guest-BlockList-Error:", Error);

        this.$message.error("Có lỗi xảy ra trong quá trình lấy dữ liệu.", 3000);
      } finally {
        this.isLoading = false;
      }
    },

    handleChange(Value, User_ID) {
      const Record = this.TBLdata.find((Item) => Item.User_ID === User_ID);

      if (!Record) {
        return;
      }

      Record.EditNote = Value;
    },

    CustEdit(User_ID) {
      const Record = this.TBLdata.find((Item) => Item.User_ID === User_ID);

      if (!Record) {
        return;
      }

      this.editingCust = User_ID;

      Record.EditNote = Record.Note || "";

      this.$set(Record, "editable", true);
    },

    CustCancel(User_ID) {
      const Record = this.TBLdata.find((Item) => Item.User_ID === User_ID);

      this.editingCust = "";

      if (!Record) {
        return;
      }

      Record.EditNote = Record.Note || "";

      this.$delete(Record, "editable");
    },

    async CustSave(User_ID) {
      const Record = this.TBLdata.find((Item) => Item.User_ID === User_ID);

      if (!Record) {
        return;
      }

      try {
        this.isLoading = true;

        const Response = await this.$PostAPI(
          "/customer/update-note",
          {
            User_ID: User_ID,

            Note: Record.EditNote,
          },
        );

        const Result = this.GetAPIData(Response);

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không cập nhật được ghi chú.",
            3000,
          );

          return;
        }

        const Customer = Result.Data && Result.Data.Customer;

        if (Customer) {
          Object.assign(Record, this.BuildRecord(Customer, Record.Index - 1));
        }

        this.editingCust = "";

        this.$delete(Record, "editable");

        this.$message.success("Đã cập nhật ghi chú.", 2000);
      } catch (Error) {
        console.log("Guest-UpdateNote-Error:", Error);

        this.$message.error("Không cập nhật được ghi chú.", 3000);
      } finally {
        this.isLoading = false;
      }
    },

    async CustBlacklist(Record) {
      try {
        this.isLoading = true;

        const Response = await this.$PostAPI(
          "/customer/blacklist",
          {
            User_ID: Record.User_ID,

            Reason: Record.Note || "Guest khóa thủ công",
          },
        );

        const Result = this.GetAPIData(Response);

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không Blacklist được khách hàng.",
            3000,
          );

          return;
        }

        const Customer = Result.Data && Result.Data.Customer;

        if (Customer) {
          const Index = this.TBLdata.indexOf(Record);

          Object.assign(Record, this.BuildRecord(Customer, Index));
        }

        this.$message.success("Đã đưa khách hàng vào Blacklist.", 2000);
      } catch (Error) {
        console.log("Guest-Blacklist-Error:", Error);

        this.$message.error("Không Blacklist được khách hàng.", 3000);
      } finally {
        this.isLoading = false;
      }
    },

    onChange(Page) {
      if (Page > 0) {
        this.page = Page;
      }

      this.editingCust = "";

      this.fillData();
    },
  },
};
</script>
